import React, { createElement } from 'react';
export function TrustedBrands() {
  const brands = [{
    name: 'Royal Canin',
    logo: 'https://logo.clearbit.com/royalcanin.com'
  }, {
    name: 'Hills Pet',
    logo: 'https://logo.clearbit.com/hillspet.com'
  }, {
    name: 'Purina',
    logo: 'https://logo.clearbit.com/purina.com'
  }, {
    name: 'Kong',
    logo: 'https://logo.clearbit.com/kongcompany.com'
  }, {
    name: 'Black Hawk',
    logo: null
  }, {
    name: 'Catit',
    logo: null
  }, {
    name: 'Seasol',
    logo: null
  }, {
    name: 'Munns',
    logo: null
  }, {
    name: 'Vetafarm',
    logo: null
  }, {
    name: 'Red Sea',
    logo: 'https://logo.clearbit.com/redseafish.com'
  }, {
    name: 'Zodiac',
    logo: null
  }, {
    name: 'API Fish Care',
    logo: null
  }];
  const BrandItem = ({
    brand
  }: {
    brand: (typeof brands)[0];
  }) => <div className="bg-white rounded-2xl px-8 py-6 shadow-sm border border-gray-100 flex items-center justify-center min-w-[200px] h-[90px] grayscale hover:grayscale-0 transition-all duration-300 cursor-pointer hover:shadow-md" data-id="element-315">
      {brand.logo ? <img src={brand.logo} alt={brand.name} className="h-10 max-w-[140px] object-contain" onError={e => {
      // Fallback to text if logo fails to load
      const target = e.target as HTMLImageElement;
      target.style.display = 'none';
      const parent = target.parentElement;
      if (parent) {
        const span = document.createElement('span');
        span.className = 'font-heading font-extrabold text-xl text-gray-700 whitespace-nowrap';
        span.textContent = brand.name;
        parent.appendChild(span);
      }
    }} data-id="element-316" /> : <span className="font-heading font-extrabold text-xl text-gray-700 whitespace-nowrap" data-id="element-317">
          {brand.name}
        </span>}
    </div>;
  return <section className="section-padding bg-warm-50 overflow-hidden" data-id="element-318">
      <div className="container-wide mb-8" data-id="element-319">
        <h2 className="font-heading font-bold text-xl text-center text-gray-500 uppercase tracking-wider" data-id="element-320">
          Trusted by the best brands in the business
        </h2>
      </div>

      {/* Marquee container */}
      <div className="relative w-full overflow-hidden" data-id="element-321">
        {/* Gradient masks */}
        <div className="absolute left-0 top-0 bottom-0 w-24 md:w-40 bg-gradient-to-r from-warm-50 to-transparent z-10 pointer-events-none" data-id="element-322"></div>
        <div className="absolute right-0 top-0 bottom-0 w-24 md:w-40 bg-gradient-to-l from-warm-50 to-transparent z-10 pointer-events-none" data-id="element-323"></div>

        {/* Single track with doubled items for seamless loop */}
        <div className="animate-marquee flex gap-6 w-max" data-id="element-324">
          {[...brands, ...brands].map((brand, index) => <BrandItem key={index} brand={brand} data-id="element-325" />)}
        </div>
      </div>
    </section>;
}